import { useRef, useState } from "react";

import FormElement from "../../store/FormElement";
import Section from "../../store/Section";

export function useEditing(elementOrSection: FormElement | Section) {
  const [isEditing, setIsEditing] = useState(false);
  const previousProperties = useRef({
    ...elementOrSection,
    arguments: { ...elementOrSection.arguments },
  });

  const start = () => {
    // Store current values of element in `previousValues` so that we can
    //  revert it if user cancels the editing.
    previousProperties.current = {
      ...elementOrSection,
      arguments: { ...elementOrSection.arguments },
    };
    setIsEditing(true);
  };
  const stop = () => setIsEditing(false);
  const cancel = () => {
    elementOrSection.setArguments(previousProperties.current.arguments);
    if (
      "setRequired" in elementOrSection &&
      "required" in previousProperties.current
    ) {
      elementOrSection.setRequired(previousProperties.current.required);
    }
    stop();
  };
  const toggle = () => {
    if (isEditing) cancel();
    else start();
  };

  return {
    value: isEditing,
    start,
    stop,
    cancel,
    toggle,
  };
}
